<template>
  <el-container>
    <el-main>
      <h3 class="heading">Create notification</h3>
      <AutomationForm
        v-if="automationItem && !loading"
        v-model="automationItem"
        :loading="loading"
        action-text="Create"
        @submit="onSubmit"
      />
      <LoadingBlock :loading="loading" />
    </el-main>
  </el-container>
</template>

<script lang="ts">
import { defineComponent, ref, watch, computed, onMounted } from 'vue'
import AutomationForm from '@/apps/traforama/views/automations/components/AutomationForm.vue'
import LoadingBlock from '@/components/LoadingBlock.vue'
import { AutomationValidationErrorsKey } from '@/api/types'
import { IAutomationAttributes, IAutomation } from '@/interfaces/automations'
import useValidation from '@/hooks/useValidation'
import useRouter from '@/hooks/useRouter'
import { ElMessage } from 'element-plus'
import { useAutomationsStore } from '@/store/modules/automations'
import { safeSubmitProcessing } from '@/utils/helpers'

export default defineComponent({
  name: 'NewAutomation',
  components: {
    AutomationForm,
    LoadingBlock
  },
  setup() {
    const automationsStore = useAutomationsStore()

    const { provideValidation, setValidationErrors } = useValidation(
      AutomationValidationErrorsKey
    )
    const errors = provideValidation()
    const loading = computed(() => automationsStore.listLoading)

    onMounted(() => {
      automationsStore.getAutomationEvents()
    })

    const automationItem = ref<IAutomationAttributes>({
      name: '',
      active: true,
      transport: 'telegram',
      event_type: '',
      message: '',
      filters: {},
      filter_options: []
    })
    const { router } = useRouter()

    const onSuccess = async () => {
      ElMessage.success({ message: 'Notification has been created' })
      router.push('/notifications')
    }

    const onSubmit = async ({
      automation
    }: {
      automation: IAutomationAttributes
    }) => {
      errors.value = {}

      await safeSubmitProcessing(
        loading,
        () => automationsStore.CreateAutomation(automation),
        (item: IAutomation) => onSuccess(item),
        (err) => setValidationErrors(err, errors)
      )
    }

    return { automationItem, loading, onSubmit }
  }
})
</script>
